// extracted by mini-css-extract-plugin
export default {"spinner":"style_spinner__PqHnk","rotation":"style_rotation__cioXJ","circle":"style_circle__fNIDI","turn":"style_turn__FNW1p","invisible":"style_invisible__RXS72"};